import { useState, useEffect } from "react";
import { Users } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function LiveVisitorCounter() {
  const [count, setCount] = useState(0);
  const [sessionId] = useState(() => localStorage.getItem("upnext_session") || Math.random().toString(36).slice(2));

  useEffect(() => {
    localStorage.setItem("upnext_session", sessionId);
    
    // Send heartbeat immediately
    sendHeartbeat();
    
    // Send heartbeat every 60 seconds (reduced from 30s)
    const interval = setInterval(sendHeartbeat, 60000);
    
    return () => clearInterval(interval);
  }, [sessionId]);

  const sendHeartbeat = async () => {
    try {
      const response = await axios.post(`${API}/analytics/visitor/heartbeat`, null, {
        params: { session_id: sessionId, page: window.location.pathname }
      });
      setCount(response.data.active_visitors);
    } catch (error) {
      // Silent fail - don't spam console
    }
  };

  if (count < 2) return null;

  return (
    <div className="fixed bottom-4 left-4 z-40 animate-fade-in hidden md:block">
      <div className="glass-card rounded-full px-4 py-2 border border-emerald-500/30 flex items-center gap-2 shadow-lg">
        <div className="relative">
          <Users className="h-4 w-4 text-emerald-400" />
          <span className="absolute -top-1 -right-1 w-2 h-2 bg-emerald-500 rounded-full animate-pulse" />
        </div>
        <span className="text-sm text-foreground">
          <span className="font-bold text-emerald-400">{count}</span>
          <span className="text-muted-foreground ml-1">orang tengah browse</span>
        </span>
      </div>
    </div>
  );
}
